(() => {
  if (window.rzExpertRecommendationsLoaded) return;
  window.rzExpertRecommendationsLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (root) => {
    if (!root || root.dataset.rzExpertsReady === 'true') return;

    const track = root.querySelector('[data-rz-experts-track]');
    const cards = Array.from(root.querySelectorAll('[data-rz-experts-card]'));
    const previous = root.querySelector('[data-rz-experts-prev]');
    const next = root.querySelector('[data-rz-experts-next]');
    const dots = Array.from(root.querySelectorAll('[data-rz-experts-dot]'));

    if (!track || cards.length === 0) return;
    root.dataset.rzExpertsReady = 'true';

    let frame;

    const cardPosition = (card) => card.offsetLeft - track.offsetLeft;

    const activeIndex = () => {
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, index) => {
        const distance = Math.abs(cardPosition(card) - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const update = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const index = activeIndex();
      const staticTrack = maxScroll <= 2;

      root.classList.toggle('is-static', staticTrack);

      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;

      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const scheduleUpdate = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    };

    const scrollToIndex = (index) => {
      const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
      track.scrollTo({
        left: cardPosition(cards[boundedIndex]),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    previous?.addEventListener('click', () => scrollToIndex(activeIndex() - 1));
    next?.addEventListener('click', () => scrollToIndex(activeIndex() + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => scrollToIndex(Number(dot.dataset.index)));
    });

    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      scrollToIndex(activeIndex() + direction);
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(track);
    } else {
      window.addEventListener('resize', scheduleUpdate);
    }

    root.rzExpertsScrollToBlock = (blockId) => {
      const card = cards.find((item) => item.dataset.blockId === blockId);
      if (card) scrollToIndex(cards.indexOf(card));
    };

    update();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-rz-experts]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-rz-experts]');
    root?.rzExpertsScrollToBlock?.(event.detail.blockId);
  });
})();
